import { render, staticRenderFns } from "./BulkEditDialog.vue?vue&type=template&id=28c7463a&"
import script from "./BulkEditDialog.vue?vue&type=script&lang=js&"
export * from "./BulkEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports